






















































































import { Component, Prop, PropSync, Vue, Watch } from "vue-property-decorator";
import { CopyGuestsReservationModel } from "./types";
import * as _ from "lodash";

@Component
export default class CopyGuestsDialog extends Vue {
  @PropSync("open") isOpen?: boolean;
  @Prop() reservationUnitId?: number;

  @Watch("isOpen")
  openWatch(fresh: boolean) {
    if (!fresh) {
      this.sourceReservationId = null;
    }
  }

  isFormValid = false;
  isLoading = false;
  sourceReservationId: number | null = null;

  copyAllGuests = true;
  copyFromUnitId: number | null = null;

  reservationModel: CopyGuestsReservationModel | null = null;
  get sourceUnits() {
    return this.reservationModel?.units ?? [];
  }
  get totalGuests() {
    return (
      this.reservationModel?.units.reduce((sum, x) => sum + x.guests, 0) ?? 0
    );
  }

  @Watch("sourceReservationId")
  sourceReservationIdWatch() {
    if (this.sourceReservationId) {
      this.debouncedLoad();
    } else {
      this.reservationModel = null;
      this.copyAllGuests = true;
      this.copyFromUnitId = null;
    }
  }

  debouncedLoad = _.debounce(this.loadReservation, 500);

  loadReservation() {
    this.isLoading = true;
    this.axios
      .get<CopyGuestsReservationModel>(
        "reservations/GetSourceReservationForGuestCopying/" +
          this.sourceReservationId
      )
      .then((res) => {
        this.reservationModel = res.data;
      })
      .catch(() => {
        this.reservationModel = null;
        this.$store.dispatch("showNotification", {
          color: "error",
          message: this.$t("CopyGuests.ReservationNotFound"),
          timeout: 5000,
        });
      })
      .finally(() => {
        this.isLoading = false;
        this.copyFromUnitId = null;
        if (this.sourceUnits.length <= 1) this.copyAllGuests = true;
      });
  }

  copyGuests() {
    const request = {
      targetReservationAccUnitId: this.reservationUnitId,
      sourceReservationId: this.sourceReservationId,
      sourceReservationAccUnitId:
        this.copyAllGuests === false ? this.copyFromUnitId : null,
    };

    this.isLoading = true;

    this.axios
      .post("/reservations/CopyGuests", request)
      .then(() => {
        this.isOpen = false;
        this.$emit("guestsCopied");
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  get rules() {
    return {
      mustHaveReservation: (value: any, reservation: any) =>
        (!!value && !!reservation) ||
        this.$t("Validation.CopyGuests.MustHaveReservation").toString(),
      required: (value: any) => !!value || this.$t("Validation.Required"),
    };
  }
}
